import * as Actions from '../constant/ActionTypes';

const initialState = []; // Initial state as an empty array

const fetchSelectedCameraReducers = (state = initialState, action) => {
    switch (action.type) {
        case Actions.SELECTED_CAMERA:
            // console.log(`fetchSelectedCameraReducers: ${JSON.stringify(action.payload)}`);
            return action.payload; // Update the state with the fetched camera data (array)
        default:
            return state; // Return the current state by default
    }
};


export default fetchSelectedCameraReducers;